import React from 'react';
import { Link } from 'react-router-dom';
import './Css/BothButtons.css';

function ColorBtn({ colorBtnLink, btnName }) {
  return (
    <button className="color-btn">
      <Link to={colorBtnLink}>{btnName}</Link>
    </button>
  );
}

export default ColorBtn;
